/**
* Link Card Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Link Card Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'link-card-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.link-card-slider' ).each( function( key, component ) {
        const splideEl = $( component ).find( '.splide--link-card-slider' )[0];
        const showArrows = $( splideEl ).data( 'show-arrows' ) !== false;

        const splide = new Splide( splideEl, {
          pagination: false,
          arrows: showArrows,
          gap: '24px',
          perPage: 3,
          perMove: 1,
          speed: 750,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'link-card-slider', COMPONENT );
} )( app );
